export const PAGINATION_PER_PAGE_LIMIT = 15;